import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { Student } from '@/models/student/student';

// 生徒プロフィール更新APIのリクエスト
export interface UpdateStudentProfilesRequest {
  schoolClassID: number;
  studentID: number;
  isValid: boolean;
}

// 生徒プロフィール更新APIのレスポンス
export class UpdateCount implements Serializable<UpdateCount> {
  count: number;

  deserialize(input: any): UpdateCount {
    this.count = input.count;
    return this;
  }
}

// クラス編成結果の編成結果確認用
export class StudentSchoolClassMovement implements Serializable<StudentSchoolClassMovement> {
  student: Student;
  oldSchoolClass: SchoolClass;
  newSchoolClass: SchoolClass;

  deserialize(input: any): StudentSchoolClassMovement {
    this.student = input.student;
    this.oldSchoolClass = input.oldSchoolClass;
    this.newSchoolClass = input.newSchoolClass;

    return this;
  }
}
